<template>
  <div v-if="state.active" class="glo-backdrop">
    <div class="glo-card">
      <div class="spinner-border" role="status" aria-hidden="true"></div>
      <div class="glo-text"><img src="/minilogo.png" style="width: 150px;"></div>
    </div>
  </div>
</template>

<script>
import { loadingState } from "@/plugins/loading";

export default {
  name: "GlobalLoadingOverlay",
  data() {
    return { state: loadingState };
  },
};
</script>

<style scoped>
.glo-backdrop{
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.35);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.glo-card{
  background: #fff;
  border-radius: 10px;
  padding: 16px 18px;
  min-width: 220px;
  max-width: 80vw;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 15px 40px rgba(15, 23, 42, 0.25);
}
.glo-text{
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}
</style>
